const API_BASE_URL = process.env.BASE_URL

export const CATALOG_ENDPOINTS = {
    CATALOGS: API_BASE_URL + "/{service_company_slug}/api/catalogs/",
    CATALOG_RESYNC: API_BASE_URL + "/{service_company_slug}/api/catalogs/{id}/resync/",
    BRANDS: API_BASE_URL + "/{service_company_slug}/api/catalogs/brands/",
    BRAND_COUNTS: API_BASE_URL + "/{service_company_slug}/api/catalogs/brands/count/",
    CATEGORIES: API_BASE_URL + "/{service_company_slug}/api/catalogs/categories/",
    ITEMS: API_BASE_URL + "/{service_company_slug}/api/catalogs/items/",
    ITEMS_COUNT: API_BASE_URL + "/{service_company_slug}/api/catalogs/items/count/",
    ITEM_DETAILS: API_BASE_URL + "/{service_company_slug}/api/catalogs/items/{id}/",
    ITEM_MODIFIERS: API_BASE_URL + "/{service_company_slug}/api/catalogs/items/{id}/modifiers/",
    SUBSCRIPTIONS: API_BASE_URL + "/{service_company_slug}/api/catalogs/subscriptions/",
    SUBSCRIPTION_DETAILS: API_BASE_URL + "/{service_company_slug}/api/catalogs/subscriptions/{id}/",
    SUBSCRIPTION_PREVIEW_COUNT: API_BASE_URL + "/{service_company_slug}/api/catalogs/subscriptions/preview-count/",
    CATALOG_LINK_DISCONNECT: API_BASE_URL + "/{service_company_slug}/api/catalogs/links/{id}/disconnect/",
    CATALOG_LINK_RECONNECT: API_BASE_URL + "/{service_company_slug}/api/catalogs/links/{id}/reconnect/",
}
